/**
  * 渐变色可切换折线柱状图
  * @param unit 单位
  * @param xData []x轴数据
  * @param dataArr [{name:'',data:[]}]y轴数据合集
  * @param type 默认样式 折线/柱状图
  * @param showChange 是否显示切换按钮,可不传不展示
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let colorList=[
    { color1: "#92D0FA", color2: "#59A3F3" },
    { color1: "#51E8E7", color2: "#28CCCB" },
    { color1: "#BAA7FB", color2: "#9C87E6" },
  ]
  let option = {
    toolbox: {
      show:paramObj.showChange,
      feature: {
        magicType: { type: ["line", "bar"] },
      },
    },
    legend: {
      color: "#333",
      fontSize: 14,
      itemWidth: 10,
      itemHeight: 10,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    grid: {
      top: "50px",
      left: "50px",
      right: "1%",
      bottom: "20px",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: { 
        color: "#CBCBCB",
        fontSize: 12,
      },
      data: paramObj.xData,
    },
    yAxis: {
      type: "value",
      name: paramObj.unit ? `单位(${paramObj.unit})` : "",
      nameTextStyle: {
        color: "#666",
        fontSize: 12,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },

      axisLabel: {
        color: "#999",
        fontSize: 12,
      },
      splitLine: {
        lineStyle: {
          type: "solid",
          color: "#EBEBEB",
        },
      },
    },
    dataZoom: [
      {
        type: "inside",
      },
    ],
    series: [],
  };
  paramObj.dataArr.forEach((v, i) => {
    option.series.push({
      name: v.name,
      type: paramObj.type?paramObj.type:'line',
      smooth: true,
      barMaxWidth: 16,
      itemStyle: {
        color: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: colorList[i].color1, // 0% 处的颜色
            },
            {
              offset: 1,
              color: colorList[i].color2, // 100% 处的颜色
            },
          ],
        },
      },
      data: v.data,
    });
  });

  return option
  
}